module.exports = {
          srcSet: __webpack_public_path__ + "public/fdc4fae4e39e4b644276ad2182fafde0-66.png"+" 66w",
          images:[ {path: __webpack_public_path__ + "public/fdc4fae4e39e4b644276ad2182fafde0-66.png",width: 66,height: 49}],
          src: __webpack_public_path__ + "public/fdc4fae4e39e4b644276ad2182fafde0-66.png",
          toString:function(){return __webpack_public_path__ + "public/fdc4fae4e39e4b644276ad2182fafde0-66.png"},
          
          width: 66,
          height: 49
        }